<template>
  <!-- If you change the input's class, shortcut events will break in RoomBottomBar which prevents key shortcuts if event.target.className == "chatInputBox"-->
  <div class="chatSubmitContainer">
    <textarea
      type="text"
      id="chatInputBox"
      class="chatInputBox"
      placeholder="Type your message here..."
      style="height: 40px"
      autocomplete="off"
      v-model="message"
      autofocus
      @input="updateInputHeight"
      @keydown.enter.exact.prevent
      @keyup.enter.exact="sendChatMessage"
    />
    <button id="chatInputSend" class="chatInputSend" @click="sendChatMessage" :disabled="sendingMessage">Send</button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { updateInputHeight } from "../../../utilities/inputFormatter";
import { constructAndLogError } from "../../../utilities/errorLogger";
import { sendChatMessage } from "../Session/SessionHelpers/chat";

export default {
  name: "FloatingChatSubmit",
  computed: {
    ...mapState({
      userCurrentChatText: (state) => state.session.userCurrentChatText,
      sendingMessage: (state) => state.session.sendingMessage,
    }),
    message: {
      get() {
        return this.userCurrentChatText;
      },
      set(value) {
        this.$store.dispatch("session/setCurrentChatText", value);
      },
    },
  },
  methods: {
    async updateInputHeight() {
      try {
        const editor = document.getElementById("chatInputBox");
        if (editor) updateInputHeight(editor);
      } catch (error) {
        await constructAndLogError(error);
      }
    },

    async sendChatMessage() {
      await sendChatMessage();
    },
  },
};
</script>

<style scoped>
.chatSubmitContainer {
  flex: 0;
  position: relative;
  flex-direction: column;
  padding: 10px 0px;
  margin-bottom: 8px;
  margin-top: 10px;
  z-index: 500;
}

.chatInputBox {
  border: 1px solid transparent;
  border-radius: 26px;
  width: 90%;
  caret-color: #383838;
  padding: 8px 16px;
  font-size: 16px;
  line-height: 22px;
  font-family: "Nunito", sans-serif;
  transition: 0.2s ease;
  box-sizing: border-box;
  outline: none;
  display: block;
  margin: 0 auto;
  padding-right: 80px;
  background-color: #ffffff;
  resize: none;
  max-height: 165px;
  box-shadow: 0 1px 4px 0 #c1c1c166;
}

/* .chatInputBox:hover {
  border-color: #ccc;
} */

.chatInputSend {
  float: right;
  box-sizing: border-box;
  padding: 4px 10px;
  background-color: #333333;
  color: white;
  font-size: 17px;
  border-radius: 360px;
  font-weight: 600;
  text-align: center;
  margin-left: auto;
  margin-right: 12px;
  margin-top: 10px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  position: absolute;
  bottom: 14px;
  right: 12px;
}

.chatInputSend:hover {
  background-color: #49494c;
}
</style>
